enum TransmissionPages {
  messages = 'page-messages',
  tickets = 'page-tickets',
}

export default TransmissionPages;
